import React, { Component } from "react";
import { Container } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import Header from "../../../components/header/header";
import Footer from "../../../components/statics/footer";
import "./profileScreen.css";
import AccountMenu from "./accountMenu";
import MyAccount from "../../../components/profile/MyAccount";
import ProfessionalInfo from "../../../components/profile/ProfessionalInfo";
import FinanceOptions from "../../../components/profile/FinanceOptions";
import * as UserProvider from "../../../providers/userProvider";
import { connect } from "react-redux";
import * as action from "../../../actions/index";
import ProfessionalFinanceOptions from "../../../components/profile/ProfessionalFinanceOptions";

const tabs = {
  myAccount: 0,
  professionalInfo: 1,
  financeOptions: 2
};

class ProfessionalProfileScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: tabs.myAccount
    };
  }
  renderContent() {
    switch (this.state.activeTab) {
      case tabs.myAccount:
        return (
          <MyAccount
            toProfessionalInfo={() =>
              this.setState({ activeTab: tabs.professionalInfo })
            }
          />
        );
      case tabs.professionalInfo:
        return <ProfessionalInfo />;
      case tabs.financeOptions:
        return <ProfessionalFinanceOptions />;
      default:
        return <MyAccount />;
    }
  }

  render() {
    /* if (!this.props.authUser) return <Redirect to={"/"} />; */
    return (
      <div className="profile-container">
        {/* <Header /> */}
        <AccountMenu
          tabs={tabs}
          activeTab={this.state.activeTab}
          onChangeTab={tab => this.setState({ activeTab: tab })}
          isProfessional={true}
        />

        <Container className="personal-profile-content">
          <div className="row justify-content-start align-items-start">
            {this.renderContent()}
          </div>
        </Container>
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    authUser: state.user.userInfo.token
  };
};
export default connect(mapStateToProps)(ProfessionalProfileScreen);
